import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
import IOSAutocapture from "../../../libraries/ios/_snippets/autocapture.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`PostHogSDK.shared.capture("user_signed_up")
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`PostHogSDK.shared.capture("user_signed_up", properties: ["login_type": "email"], userProperties: ["is_free_trial": true])
`}</code></pre>
    <h2 {...{
      "id": "autocapture"
    }}>{`Autocapture`}</h2>
    <IOSAutocapture mdxType="IOSAutocapture" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      